import React, { useState } from 'react';
import { useRouteNode } from 'react-router5';

import Tab from '../components/tab/tab';
import {
  setFocusContact, setFocusEntity, setFocusTheme,
  setNotifyContact, setNotifyEntity, setNotifyTheme
} from "../api";

import ContactFocus from './focus_contact';
import EntityFocus from './focus_entity';
import ThemeFocus from './focus_theme';
import {useTranslation} from "react-i18next";

import './style/focus.css';


function ShowEditBar({ edit, onBack, onCancel, onSave, onEdit }) {
  const { t } = useTranslation();
  return (
    <div className="c-container_showedit-bar">
      <div className="c-showedit_bar-back-icon" onClick={onBack}/>
      <div className="c-showedit_text">{t('Mes focus')}</div>
      { edit && <div className="c-showedit_cancel_button" onClick={onCancel}>{t('Annuler')}</div> }
      { edit && <div className="c-showedit_validate_button" onClick={onSave}>{t('Valider')}</div> }
      { !edit && <div className="c-showedit_bar-edit-icon" onClick={onEdit} /> }
    </div>
  )
}



// WARNING SET MUST BE DONE AND VALIDATED BEFORE
// UNSET, OTHERWISE they will be updated both at the same time which
// will create a conflict (forgot first update)
const updateFocus = ({contact, entity, theme}) => {
  const promises_set = [
    // focus set
    contact.focus_set.map(id => setFocusContact(id, "set")),
    entity.focus_set.map(id => setFocusEntity(id, "set")),
    theme.focus_set.map(id => setFocusTheme(id, "set")),
    // notif set
    contact.notif_set.map(id => setNotifyContact(id, "set")),
    entity.notif_set.map(id => setNotifyEntity(id, "set")),
    theme.notif_set.map(id => setNotifyTheme(id, "set")),
  ];

  return Promise.all(promises_set.flat()).then(() => {
    const promises_unset = [
      // focus unset
      contact.focus_unset.map(id => setFocusContact(id, "unset")),
      entity.focus_unset.map(id => setFocusEntity(id, "unset")),
      theme.focus_unset.map(id => setFocusTheme(id, "unset")),
      // notify unset
      contact.notif_unset.map(id => setNotifyContact(id, "unset")),
      entity.notif_unset.map(id => setNotifyEntity(id, "unset")),
      theme.notif_unset.map(id => setNotifyTheme(id, "unset")),
    ];

    return Promise.all(promises_unset.flat())
  })
}

// take set/unset of ids and make API calls
const onSaveFocus = (saved_contacts, saved_entities, saved_themes) => {
  let contact_set = [], contact_unset = [];
  let entity_set = [], entity_unset = [];
  let theme_set = [], theme_unset = [];

  saved_contacts.forEach(contact => {
    if (contact.new_star === true) { contact_set.push(contact.id); }
    else if (contact.new_star === false) { contact_unset.push(contact.id); }
  });

  saved_entities.forEach(entity => {
    if (entity.new_star === true) { entity_set.push(entity.id); }
    else if (entity.new_star === false) { entity_unset.push(entity.id); }
  });

  saved_themes.forEach(theme => {
    if (theme.new_star === true) { theme_set.push(theme.id); }
    else if (theme.new_star === false) { theme_unset.push(theme.id); }
  });

  let contact_notif_set = [], contact_notif_unset = [];
  let entity_notif_set = [], entity_notif_unset = [];
  let theme_notif_set = [], theme_notif_unset = [];

  saved_contacts.forEach(contact => {
    if (contact.new_notification === true) { contact_notif_set.push(contact.id); }
    else if (contact.new_notification === false) { contact_notif_unset.push(contact.id); }
  });

  saved_entities.forEach(entity => {
    if (entity.new_notification === true) { entity_notif_set.push(entity.id); }
    else if (entity.new_notification === false) { entity_notif_unset.push(entity.id); }
  });

  saved_themes.forEach(theme => {
    if (theme.new_notification === true) { theme_notif_set.push(theme.id); }
    else if (theme.new_notification === false) { theme_notif_unset.push(theme.id); }
  });

  return updateFocus({
    contact: {
      focus_set: contact_set, focus_unset: contact_unset,
      notif_set: contact_notif_set, notif_unset: contact_notif_unset
    },
    entity: {
      focus_set: entity_set, focus_unset: entity_unset,
      notif_set: entity_notif_set, notif_unset: entity_notif_unset
    },
    theme: {
      focus_set: theme_set, focus_unset: theme_unset,
      notif_set: theme_notif_set, notif_unset: theme_notif_unset,
    },
  })
}

function Focus() {
  const { router } = useRouteNode('profile.focus');
  const { t } = useTranslation();

  const  {name, data} = router.getState();

  let [,, route_end] = name.split('.');
  route_end = (route_end === undefined) ? "show_contact" : route_end;
  const [mode, type] = route_end && route_end.split("_");
  const is_edit = mode === "edit";

  const [saved_entities, notifyEntities] = useState([]);
  const [saved_contacts, notifyContacts] = useState([]);
  const [saved_themes, notifyThemes] = useState([]);

  // could be loaded... even though it's about to be removed
  if (name === "profile") return false;

  function onBack() {
    if (is_edit) {
      onCancel();
    } else {
      router.navigate('profile',{}, {reload: true});
    }
  }
  function onCancel() {
    // TODO: set warning? (will loose edition)
    router.navigate('profile.focus.show_' + type);
  }
  function onEdit() {
    router.navigate('profile.focus.edit_' + type);
  }

  function onSave() {
    // TODO: error handling
    onSaveFocus(saved_contacts, saved_entities, saved_themes).then(() => {
      router.navigate('profile.focus.show_' + type, {}, {
        reload_keys: ["focus_contact", "focus_entity", "focus_theme"]
      });
    })
  }

  const tabContent = [
    {"title": t("Contacts"), "root": `profile.focus.${mode}_contact`},
    {"title": t("Entités"), "root": `profile.focus.${mode}_entity`},
    {"title": t("Thèmes"), "root": `profile.focus.${mode}_theme`},
  ]


  let view = false;
  if (type === "contact") {
    view = <ContactFocus key={route_end} mode={mode}
            contacts={data.contacts} focus={data.focus_contact} notify={notifyContacts} />
  } else if (type === "entity") {
    view = <EntityFocus key={route_end} mode={mode}
            entities={data.entities} focus={data.focus_entity} notify={notifyEntities} />
  } else if (type === "theme") {
    const theme_mode = mode === "show" ? { display: "focus_only", editable: false } : { display: "all", editable: true };

    view = <ThemeFocus key={route_end} mode={theme_mode}
            themes={data.themes} focus={data.focus_theme} notify={notifyThemes} />
  }

  return <section className="c-container container_two" style={{width: "50%"}}>
    { <ShowEditBar edit={is_edit} onBack={onBack}
      onCancel={onCancel} onSave={onSave} onEdit={onEdit} /> }

    <div className="c-container_menu">
      <Tab active={0}>
        {
          tabContent.map((tab, idx) => (
            <Tab.TabPane key={`Tab-${idx}`} tab={tab.title} root={tab.root}></Tab.TabPane>)
          )
        }
      </Tab>
    </div> {/*menu  Tabs */}
    { view }
  </section>
}


export default Focus
